import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { applicationsStateForAccountIdAndStatusSelector } from '../../reducers/application-selectors';

import * as Api from '../../api/api';

export const loadAccountApplicationsByStatus = (
  accountId: number,
  statuses: Array<ApplicationStatus>,
) =>
  createGenericDispatcher<Array<FullApplicant>>({
    name: 'LOAD_ACCOUNT_APPLICATIONS_BY_STATUS',
    loadFunction: () =>
      Api.get(`/applications?accountId=${accountId}&status=${statuses.join('&status=')}`),
    args: { accountId, statuses },
    shouldExecuteSelectors: (state: any) =>
      statuses.map((s) => applicationsStateForAccountIdAndStatusSelector(state, accountId, s)),
  });
